import React, {useEffect, useState} from 'react';
import {Layout} from 'antd';
import {useNavigate} from 'react-router';
import {toast} from 'react-toastify';

//Components
import {Sidebar} from '../../../Components/Sidebar/Sidebar';
import {HeaderBar} from '../../../Components/Header/Header';
import PageContentHeader from '../../../Components/CoreComponents/PageContentHeader';
import Loader from '../../../Components/CoreComponents/Loader';
import EditFileFormComponent from "../../../Components/CoreComponents/EditFileFormComponent";


//CSS
import '../ProjectView/ProjectDetail.css';

import { useParams } from 'react-router-dom';
import { getFile, getDirectoryList } from '../../../Network/Core/Directory/DirectoryServices';
import { getProjectList } from '../../../Network/Core/Project/ProjectServices';

const {Content} = Layout;

export const EditFile = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [file, setFile] = useState<any>();
    const [siblingNames, setSiblingNames] = useState<string[]>([]);
    const {id} = useParams()

    useEffect(() => {
        (async () => {
            await getFileDetail()
        })()
    }, []);

    const navigate = useNavigate();

    const getFileDetail = async () => {
        if (id) {
            try {
                const response = await getFile(id);
                const data = response?.data;
                if (!data) {
                    toast.error('File not found');
                    navigate(-1);
                    return;
                }
                setFile(data);

                try {
                    let siblings: any[] = [];
                    if (data.parentId) {
                        const dirData = (await getDirectoryList(data.parentId)).data;
                        siblings = dirData?.files || [];
                    } else if (data.projectId) {
                        const projData = (await getProjectList(data.projectId)).data;
                        siblings = projData?.files || [];
                    }
                    setSiblingNames(
                        siblings.filter((f: any) => f.id !== data.id).map((f: any) => f.name)
                    );
                } catch (e) {
                    // Non-critical: name validation won't work but file can still be edited
                }
            } catch (error) {
                toast.error('Failed to load file');
                navigate(-1);
                return;
            } finally {
                setIsLoading(false);
            }
        } else {
            toast.error('Invalid file');
            navigate(-1);
        }
    };
    return (
        <>
            {isLoading && <Loader/>}
            <Layout className="layout_wrapper">
                <HeaderBar activePopupLink=""/>
                <Layout>
                    <Sidebar currentVal="files-list"/>
                    <Content>
                        <PageContentHeader
                            headerTitle="Edit File"
                            showSearchBar={false}
                            showStatus={false}
                            MapSelect={false}
                        />
                        <div className="Main-content-box">
                            {file && (
                                <EditFileFormComponent FormTitle="edit-file" file={file} siblingNames={siblingNames}/>
                            )}
                        </div>
                    </Content>
                </Layout>
            </Layout>
        </>
    );
};
